import { render, staticRenderFns } from "./ModalAltaCliente.vue?vue&type=template&id=cc3fe5fa&scoped=true&"
import script from "./ModalAltaCliente.vue?vue&type=script&lang=js&"
export * from "./ModalAltaCliente.vue?vue&type=script&lang=js&"
import style0 from "./ModalAltaCliente.vue?vue&type=style&index=0&id=cc3fe5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3fe5fa",
  null
  
)

export default component.exports